var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1111 11.4441L22.4037 9.46857C23.4172 8.86049 23.9239 8.55646 24.3408 8.59532C24.7044 8.62921 25.0361 8.81701 25.2522 9.11132C25.5 9.44884 25.5 10.0398 25.5 11.2217V16.7777C25.5 17.9596 25.5 18.5505 25.2522 18.888C25.0361 19.1823 24.7044 19.3701 24.3408 19.404C23.9239 19.4429 23.4172 19.1389 22.4037 18.5308L19.1111 16.5552M6.58889 21.6663H15.0222C16.4535 21.6663 17.1691 21.6663 17.7158 21.3878C18.1966 21.1428 18.5876 20.7518 18.8326 20.271C19.1111 19.7243 19.1111 19.0087 19.1111 17.5775V10.4219C19.1111 8.99065 19.1111 8.27503 18.8326 7.72837C18.5876 7.24751 18.1966 6.85656 17.7158 6.61155C17.1691 6.33301 16.4535 6.33301 15.0222 6.33301H6.58889C5.15764 6.33301 4.44202 6.33301 3.89536 6.61155C3.4145 6.85656 3.02355 7.24751 2.77854 7.72837C2.5 8.27503 2.5 8.99065 2.5 10.4219V17.5775C2.5 19.0087 2.5 19.7243 2.77854 20.271C3.02355 20.7518 3.4145 21.1428 3.89536 21.3878C4.44202 21.6663 5.15764 21.6663 6.58889 21.6663Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoCall);
export default __webpack_public_path__ + "static/media/video-call.1f64991ce67e1feb5cb91c0cfd1f5e3a.svg";
export { ForwardRef as ReactComponent };